import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from 'swiper/modules';
import { ColorPicker } from "primereact/colorpicker";
import { postData } from "@/services/api.service";
import { toast } from "react-toastify";
import { fetchCroppedImage } from '@/utils/constants';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
import { setTemplateImages } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';

const HomeEditBannerOurServicesModal = ({ themeData, getThemeData }: any) => {
  const dispatch = useDispatch<any>();
  const [editData, setEditData] = useState<any>(themeData);
  const [activeTab, setActiveTab] = useState(0);
  const [imagedata, setImagedata] = useState<any>(null);
  const data: any = useSelector<any>((state) => state.homeJsonList);
  const section6 = editData?.theme_5?.home?.section_our_services;

  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [iconImages, setIconImages] = useState<string[]>([]);

  const icons = [
    "assets/img/services/service-icon-1.png",
    "assets/img/services/service-icon-2.png",
    "assets/img/services/service-icon-3.png",
    "assets/img/services/service-icon-4.png",
    "assets/img/services/service-icon-5.png",
    "assets/img/services/service-icon-6.png",
    "assets/img/services/service-icon-7.png",
    "assets/img/services/service-icon-8.png",
    "assets/img/services/service-icon-9.png"
  ];
  useEffect(() => {
    if (data && data.theme_5) {
      setEditData(data);
    }
  }, [data]);

  useEffect(() => {
    if (themeData && themeData.theme_5) {
      setEditData(themeData);
    }
  }, [themeData]);

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };
  const handleChange = (e: any, index?: any) => {
    const { value, name, type, checked } = e.target;

    if (index != undefined) {
      // Update card-specific fields
      const updatedCollection = [
        ...(editData?.theme_5?.home?.section_our_services?.service_section?.services || []),
      ];
      updatedCollection[index] = {
        ...updatedCollection[index],
        [name]: value,
      };

      setEditData((prevJsonData: any) => ({
        ...prevJsonData,
        theme_5: {
          ...prevJsonData?.theme_5,
          home: {
            ...prevJsonData?.theme_5?.home,
            section_our_services: {
              ...prevJsonData?.theme_5?.home?.section_our_services,
              service_section: {
                ...prevJsonData?.theme_5?.home?.section_our_services?.service_section,
                services: updatedCollection,
              },
            },
          },
        },
      }));
    } else {
      // Update top-level fields (title, button fields)
      setEditData((prevJsonData: any) => ({
        ...prevJsonData,
        theme_5: {
          ...prevJsonData?.theme_5,
          home: {
            ...prevJsonData?.theme_5?.home,
            section_our_services: {
              ...prevJsonData?.theme_5?.home?.section_our_services,
              [name]: value,
              btn_group: {
                ...prevJsonData?.theme_5?.home?.section_our_services?.btn_group,
                btn1: {
                  ...prevJsonData?.theme_5?.home?.section_our_services?.btn_group?.btn1,
                  [name]: value,
                },
              },
            },
          },
        },
      }));
    }
  };

  const removeCollection = (index: any) => {
    const currentServices = editData?.theme_5?.home?.section_our_services?.service_section?.services || [];
    let updatedCollection = [...currentServices];
    updatedCollection.splice(index, 1);
    setActiveTab(Math.max(0, activeTab - 1));
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        ...prevJsonData?.theme_5,
        home: {
          ...prevJsonData?.theme_5?.home,
          section_our_services: {
            ...prevJsonData?.theme_5?.home?.section_our_services,
            service_section: {
              ...prevJsonData?.theme_5?.home?.section_our_services?.service_section,
              services: updatedCollection,
            },
          },
        },
      },
    }));
  };
  const handleImageChange = (image: string, index: any) => {
    const currentServices = editData?.theme_5?.home?.section_our_services?.service_section?.services || [];
    const updatedCollection = [...currentServices];
    updatedCollection[index] = {
      ...updatedCollection[index],
      service_image: image,
    };

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        ...prevJsonData?.theme_5,
        home: {
          ...prevJsonData?.theme_5?.home,
          section_our_services: {
            ...prevJsonData?.theme_5?.home?.section_our_services,
            service_section: {
              ...prevJsonData?.theme_5?.home?.section_our_services?.service_section,
              services: updatedCollection,
            },
          },
        },
      },
    }));
  };

  const handleCroppedImage = async (image: any) => {
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChange(imageLink, activeTab);
    }
  };


  const updateImageSection = async (e: any) => {
    const image = e.target.files[0];
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  const addCollection = () => {
    const currentServices = editData?.theme_5?.home?.section_our_services?.service_section?.services || [];
    let updatedCollection: any = [...currentServices];

    let newCard = {
      service_title: "",
      service_image: "assets/img/services/service-icon-1.png",
      isEnabled: true,
      service_description: "",
      service_text: "",
      bg_color: "",
      color: "",
      service_link: ""
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        ...prevJsonData?.theme_5,
        home: {
          ...prevJsonData?.theme_5?.home,
          section_our_services: {
            ...prevJsonData?.theme_5?.home?.section_our_services,
            service_section: {
              ...prevJsonData?.theme_5?.home?.section_our_services?.service_section,
              services: updatedCollection,
            },
          },
        },
      },
    }));
  };
  // Auto-generate prompt based on current card context for Icon
  const generateAutoPromptIcon = (): string => {
    const currentCard = editData?.theme_5?.home?.section_our_services?.service_section?.services?.[activeTab];
    const cardTitle = currentCard?.service_title || '';
    const cardDescription = currentCard?.service_description || '';
    const cardText = currentCard?.service_text || '';
    const sectionTitle = editData?.theme_5?.home?.section_our_services?.title || '';

    let contextPrompt = 'modern minimalist icon design';

    if (cardTitle || cardDescription || cardText || sectionTitle) {
      const contextParts: string[] = [];
      if (cardDescription) {
        const keywords = cardDescription.split(' ').slice(0, 3).join(' ');
      } else if (cardText) {
        const keywords = cardText.split(' ').slice(0, 3).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }

    contextPrompt += ', clean modern minimalist icon, professional design, suitable for service card icon, vibrant colors, high quality, simple and recognizable, no text, no words, no letters, no typography';

    return contextPrompt;
  };

  // Handle AI icon save
  const handleAIIconSave = (iconUrl: string) => {
    handleImageChange(iconUrl, activeTab);
    setIconImages(prevIcons => [...prevIcons, iconUrl]);

    const templateKey = template ? `template${template}` : 'template5';
    const currentTemplate = templateImages[templateKey] || {};
    const currentIcons = currentTemplate.icon || [];
    const updatedTemplateImages = {
      ...templateImages,
      [templateKey]: {
        ...currentTemplate,
        icon: [...currentIcons, { url: iconUrl }],
      },
    };
    dispatch(setTemplateImages(updatedTemplateImages));
  };


  // Load existing template images from Redux store with filtering
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template5';
      const currentTemplate = templateImages[templateKey];
      const iconImgs = currentTemplate?.icon || [];

      // Helper function to load image dimensions
      const loadImageDimensions = async (url: string): Promise<{ url: string; width: number; height: number } | null> => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            resolve({ url, width: img.width, height: img.height });
          };
          img.onerror = () => {
            resolve(null);
          };
          img.src = url;
        });
      };

      // Load and filter icon images
      if (Array.isArray(iconImgs) && iconImgs.length > 0) {
        const filterIconImages = async () => {
          const iconPromises = iconImgs.map((img: any) => loadImageDimensions(img.url));
          const loadedIcons = await Promise.all(iconPromises);

          // Filter for square/icon images (aspect ratio 0.9-1.1)
          const squareIcons = loadedIcons
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);

          setIconImages(squareIcons);
        };

        filterIconImages();
      } else {
        setIconImages([]);
      }
    } else {
      setIconImages([]);
    }
  }, [templateImages, template]);

  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section Our Services Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">
                      Title<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={section6?.title}
                      onChange={(e) => {
                        if (e.target.value.length < 120) {
                          handleChange(e);
                        }
                      }}
                      maxLength={250}
                    />
                  </div>
                  <div className="mb-3">
                    <div className="row">
                      <div className="col">
                        <div className="mb-3">
                          <label className="form-label">Button</label>
                          <input
                            type="text"
                            className="form-control"
                            name="text"
                            value={
                              editData?.theme_5?.home?.section_our_services?.btn_group?.btn1
                                ?.text
                            }
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col">
                        <div className="mb-3">
                          <label className="form-label">Background</label>
                          <div className="input-group color-change">
                            <input
                              type="text"
                              className="form-control"
                              name="bg_color"
                              value={
                                editData?.theme_5?.home?.section_our_services?.btn_group?.btn1
                                  ?.bg_color
                              }
                              onChange={handleChange}
                            />
                            <ColorPicker
                              name="bg_color"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              format="hex"
                              value={
                                editData?.theme_5?.home?.section_our_services?.btn_group?.btn1
                                  ?.bg_color
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="mb-3">
                          <label className="form-label">Color</label>
                          <div className="input-group color-change">
                            <input
                              type="text"
                              className="form-control"
                              name="color"
                              value={
                                editData?.theme_5?.home?.section_our_services?.btn_group?.btn1
                                  ?.color
                              }
                              onChange={handleChange}
                            />
                            <ColorPicker
                              name="color"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              format="hex"
                              value={
                                editData?.theme_5?.home?.section_our_services?.btn_group?.btn1
                                  ?.color
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_5?.home?.section_our_services?.service_section?.services.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option">
                          <a
                            className={`nav-link ${activeTab === index ? "active" : ""
                              }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Card Section {index + 1}
                          </a>
                          <a
                            className="tab-close"
                            onClick={() => {
                              removeCollection(index);
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_5?.home?.section_our_services?.service_section?.services.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${activeTab === index ? "show active" : ""
                        }`}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active">
                            <img
                              src={card.service_image}
                              alt={`Card Icon ${index + 1}`}
                            />
                          </div>
                          <div className="img-options w-100">
                            {iconImages.length > 0 ? (
                              <Swiper
                                spaceBetween={15}
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                  640: {
                                    slidesPerView: 1,
                                  },
                                  768: {
                                    slidesPerView: 4,
                                  },
                                  1024: {
                                    slidesPerView: 6,
                                  },
                                }}
                                className="homejson-slider"
                              >
                                {iconImages.map((iconUrl: string, iconIndex: number) => (
                                  <SwiperSlide key={iconIndex}>
                                    <div
                                      className="img-option"
                                      onClick={() =>
                                        handleImageChange(iconUrl, index)
                                      }
                                    >
                                      <img
                                        src={iconUrl}
                                        alt="Hero Image"
                                        className="img-fluid"
                                      />
                                    </div>
                                  </SwiperSlide>
                                ))}
                              </Swiper>
                            ) : (
                              <div className="empty-slider-state text-center py-4">
                                <div className="empty-state-content">
                                  <i className="fas fa-icons fa-3x text-muted mb-3"></i>
                                  <h6 className="text-muted mb-2">No Icons Available</h6>
                                  <p className="text-muted small mb-3">
                                    Generate AI icons or upload your own to see them here
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* AI Image Generator */}
                      <AIImageGenerator
                        generateAutoPrompt={generateAutoPromptIcon}
                        onSave={handleAIIconSave}
                        imageType="icon"
                        defaultWidth="128"
                        defaultHeight="128"
                        title="AI Icon"
                        autoGenerate={true}
                        template={template}
                      />

                      <div className="mb-3">
                        <label className="form-label">Upload Image</label>
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          className="form-control"
                          name="image"
                          onChange={updateImageSection}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="row">
                          <div className="col">
                            <label className="form-label">Background Color</label>
                            <div className="input-group color-change">
                              <input
                                type="text"
                                className="form-control"
                                name="bg_color"
                                value={card?.bg_color || ""}
                                onChange={(e) => handleChange(e, index)}
                              />
                              <ColorPicker
                                name="bg_color"
                                onChange={(e) => {
                                  handleChange(e, index);
                                }}
                                format="hex"
                                value={card?.bg_color || ""}
                              />
                            </div>
                          </div>
                          <div className="col">
                            <label className="form-label">Font Color</label>
                            <div className="input-group color-change">
                              <input
                                type="text"
                                className="form-control"
                                name="color"
                                value={card?.color || ""}
                                onChange={(e) => handleChange(e, index)}
                              />
                              <ColorPicker
                                name="color"
                                onChange={(e) => {
                                  handleChange(e, index);
                                }}
                                format="hex"
                                value={card?.color || ""}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Title<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="service_title"
                          value={card.service_title}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Link</label>
                        <input
                          type="text"
                          className="form-control"
                          name="service_link"
                          value={card.service_link || ""}
                          onChange={(e) => handleChange(e, index)}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                          <label className="form-label mb-0 mr-2">Paragraph</label>
                          <AIContentWriter
                            onContentGenerated={(content) => {
                              handleChange({
                                target: {
                                  name: 'service_description',
                                  value: content,
                                },
                              }, index);
                            }}
                            contentType="product_description"
                            placeholder="Describe this service. Example: 'Write about professional washing service with quick turnaround'"
                            context="This is for a laundry service card description with 1 liner or 10 words max"
                          />
                        </div>
                        <small>(max 1200 char)</small>
                        <textarea
                          className="form-control"
                          name="service_description"
                          value={card.service_description}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={1200}
                          rows={3}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                          <label className="form-label mb-0 mr-2">Description</label>
                          <AIContentWriter
                            onContentGenerated={(content) => {
                              handleChange({
                                target: {
                                  name: 'service_text',
                                  value: content,
                                },
                              }, index);
                            }}
                            contentType="product_description"
                            placeholder="Describe this service. Example: 'Write about professional washing service with quick turnaround'"
                            context="This is for a laundry service card description with 1 liner or 10 words max"
                          />
                        </div>
                        <small>(max 1200 char)</small>
                        <textarea
                          className="form-control"
                          name="service_text"
                          value={card.service_text}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={1200}
                          rows={3}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Upload Image</label>
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          className="form-control"
                          name="image"
                          onChange={updateImageSection}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="edit-section">
              <div className="row">
                <div
                  onClick={() => {
                    addCollection();
                  }}
                  className="col text-center"
                >
                  Add Card<i className="fas fa-plus-square ms-2"></i>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonData();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomeEditBannerOurServicesModal;
